import { Logo } from '@/components/Logo';

/** Both marks keep their own proportions and clear space. */
export default function BrandLockup({ tone = 'light', stacked = false, className = '' }) {
  return <div className={`brand-lockup ${stacked ? 'brand-lockup-stacked' : ''} ${className}`} data-tone={tone}>
    <span className="haramain-wordmark" role="img"
      aria-label="الحرمين — الهيئة العامة للعناية بشؤون المسجد الحرام والمسجد النبوي" />
    <span className="brand-lockup-divider" aria-hidden="true" />
    <Logo variant={tone === 'light' ? 'dark' : 'light'} textSize="text-base" />
  </div>;
}
